export default __webpack_public_path__ + "static/media/dp.adf90655.png";